import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 厂站分页
    GetAllStation({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Station/GetAllStation', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存厂站
    SaveStation({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Station/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除厂站
    DeleteStation({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Equipment/Station/DeleteByObjectID', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取配电室list
    GetPDSList({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Equipment/Station/GetSelectJsonForPDS', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
